// Sprint 1 — Onboarding post-registro
import { css, cx } from "styled-system/css";
import { cf } from "@/components/brand/sfturnos-styles";
import { useOnboardingWizard } from "@/context/onboarding-wizard-context";

export function OnboardingStepContact() {
  const { state, dispatch } = useOnboardingWizard();

  return (
    <div>
      <h1 className={css({ fontSize: "2xl", fontWeight: "bold", color: "#0f172a", mb: "2" })}>Contacto</h1>
      <p className={css({ fontSize: "sm", color: "#64748b", mb: "6", maxW: "40rem", lineHeight: 1.6 })}>
        Un teléfono de contacto ayuda a que tus clientes sepan cómo ubicarte ante cualquier inconveniente.
      </p>

      <label className={css({ display: "block", mb: "8" })}>
        <span className={css({ fontSize: "sm", fontWeight: "medium", color: "#334155", display: "block", mb: "2" })}>
          Teléfono (opcional)
        </span>
        <input
          type="tel"
          value={state.phone}
          onChange={(e) => dispatch({ type: "SET_FIELD", field: "phone", value: e.target.value })}
          className={cf.input}
          placeholder="Ej. +54 11 1234-5678"
          autoComplete="tel"
        />
        <span className={css({ fontSize: "xs", color: "#64748b", mt: "1.5", display: "block" })}>
          Ante cualquier inconveniente, tus clientes sabrán cómo contactarte.
        </span>
      </label>

      <button
        type="button"
        onClick={() => dispatch({ type: "NEXT_STEP" })}
        className={cx(
          cf.linkPrimaryOnDark,
          css({
            px: "6",
            py: "3",
            border: "none",
            fontSize: "sm",
            cursor: "pointer",
            bg: "linear-gradient(90deg, token(colors.brand.600), token(colors.brand.500))",
          }),
        )}
      >
        Continuar
      </button>
    </div>
  );
}
